import api from "../../utils/apiUser";
import { desempaquetarLista } from "../../utils/listaPaginada";

export const getInventarioProducto = async (productoId) => {
  const res = await api.get(`/api/inventario/${productoId}`);
  return res.data;
};

export const cargarInventario = async ({
  producto_id,
  cantidad,
  observacion
}) => {
  const res = await api.post("/api/inventario/cargar", {
    producto_id,
    cantidad,
    observacion
  });

  return res.data;
};

export const ajustarInventario = async ({
  producto_id,
  cantidad,
  observacion
}) => {
  const res = await api.post("/api/inventario/ajustar", {
    producto_id,
    cantidad,
    observacion
  });

  return res.data;
};

export const getInventarioHistorial = async (productoId, { limit = 200, offset = 0 } = {}) => {
  const res = await api.get(`/api/inventario/historial/${productoId}`, {
    params: { limit, offset },
  });
  return desempaquetarLista(res.data);
};
